import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface ParsedPaystub {
  grossPay?: number | null;
  netPay?: number | null;
  hours?: number | null;
  ratePerHour?: number | null;
  periodStart?: string | null;
  periodEnd?: string | null;
  payDate?: string | null;
  payer?: string | null;
  checkOrConfirmationNumber?: string | null;
  warnings: string[];
  confidence: number;
}

export interface IngestPaystubInput {
  depositAccountId: string;
  grossAmount: number;
  netAmount?: number;
  hours?: number;
  periodStart?: string;
  periodEnd?: string;
  payDate?: string;
  payer?: string;
  invoiceNumber?: string;
  checkOrConfirmationNumber?: string;
}

export interface IngestPaystubResult {
  invoiceId: string;
  transactionId: string;
  invoiceNumber: string;
}

export function useParsePaystub() {
  return useMutation({
    mutationFn: async (rawText: string): Promise<ParsedPaystub> => {
      const r = await api().post<ParsedPaystub>("/api/paystubs/parse", { rawText });
      return r.data;
    },
  });
}

export function useIngestPaystub() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: IngestPaystubInput): Promise<IngestPaystubResult> => {
      const r = await api().post<IngestPaystubResult>("/api/paystubs/ingest", input);
      return r.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["money", "invoices"] });
      qc.invalidateQueries({ queryKey: ["money", "transactions"] });
      qc.invalidateQueries({ queryKey: ["money", "accounts"] });
    },
  });
}
